export default function YomaLogo({ width = 180, height = 60 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 600 200"
      width={width}
      height={height}
      aria-label="YOMA DESIGN"
    >
      <style>
        {`
        .yoma { font-family: "Playfair Display", serif; font-size: 80px; letter-spacing: 20px; fill: #b8a899; }
        .design { font-family: "Montserrat", sans-serif; font-size: 28px; letter-spacing: 12px; fill: #b8a899; }
      `}
      </style>
      <text x="50%" y="90" textAnchor="middle" className="yoma">
        YOMA
      </text>
      <text x="50%" y="150" textAnchor="middle" className="design">
        DESIGN
      </text>
    </svg>
  );
}

